import { defineComponent as _defineComponent } from 'vue'

const __default__ = {}

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OzIndeterminateSpinner',
  props: {
    size: { default: 20 },
    darkMode: { type: [Boolean, String], default: 'auto' }
  },
  setup(__props: any) {

const props = __props as { size: number, darkMode: boolean | 'auto' }



const spinnerStyles = computed(() => ({
  width: props.size + 'px',
  height: props.size + 'px',
}))

return { __sfc: true,props, spinnerStyles }
}

})